/**
 * Online Order Form DB Service REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OofBeltDto } from './oofBeltDto';
import { UserRolesValue } from './userRolesValue';
import { ProximityConfiguration } from './proximityConfiguration';
import { OofDropOffConfigurationDto } from './oofDropOffConfigurationDto';
import { IotConfig } from './iotConfig';
import { ScheduleFileDtoString } from './scheduleFileDtoString';
import { MagnetometerConfig } from './magnetometerConfig';
import { ScheduleFileDtoListString } from './scheduleFileDtoListString';


export interface FormDataDto { 
    animalSpecies?: string;
    plannedDeploymentDate?: string;
    requestedDeliveryDate?: string;
    prioListNo?: number;
    vhfBeaconFrequencies?: string;
    fixedAssignmentVhfFrequenciesDescription?: string;
    customerName?: string;
    deviceComment?: string;
    productionRecordComment?: string;
    isBatteryFix?: boolean;
    batteryShape?: FormDataDto.BatteryShapeEnum;
    batterySize?: FormDataDto.BatterySizeEnum;
    batteryWithDropOff?: boolean;
    internalDropOff?: OofDropOffConfigurationDto;
    externalDropOff?: OofDropOffConfigurationDto;
    belt?: OofBeltDto;
    beltColorDE?: string;
    housingLabel?: string;
    dataPlan?: FormDataDto.DataPlanEnum;
    shouldUnsubscribeIridiumPlan?: boolean;
    iridiumMode?: number;
    ownIridiumProvider?: boolean;
    globalstarMode?: number;
    globalstarOperationCountry?: string;
    globalstarChannel?: string;
    gsmMode?: number;
    iotMode?: number;
    gsmDestinationNumber?: string;
    uhfCommunication?: string;
    accSampleRate?: string;
    accSensorRange?: string;
    mortalityMode?: boolean;
    mortalityPeriod?: number;
    lateralMortality?: boolean;
    utcCorrection?: number;
    gpsSchedule?: ScheduleFileDtoString;
    vhfSchedule?: ScheduleFileDtoListString;
    gpsSkipCount?: number;
    emailNotifications?: Array<string>;
    smsNotifications?: Array<string>;
    communicationSchedule?: ScheduleFileDtoString;
    idTag?: boolean;
    proximity?: ProximityConfiguration;
    virtualFenceMode?: string;
    virtualFenceSchedule?: ScheduleFileDtoString;
    kmlFile?: string;
    hibernationMode?: boolean;
    hibernationPeriod?: number;
    hibernationWakeupLevel?: number;
    specialRequest?: string;
    userRoles?: UserRolesValue;
    magnetometer?: MagnetometerConfig;
    iot?: IotConfig;
    context?: { [key: string]: object; };
}
export namespace FormDataDto {
    export const BatteryShapeEnum = {
        Square: 'SQUARE',
        Curved: 'CURVED'
    } as const;
    export type BatteryShapeEnum = typeof BatteryShapeEnum[keyof typeof BatteryShapeEnum];
    export const BatterySizeEnum = {
        _1C: '1C',
        _1D: '1D',
        _2D: '2D',
        _3D: '3D',
        _4D: '4D',
        _5D: '5D',
        _6D: '6D',
        _7D: '7D',
        _15D: '15D',
        _26C: '26C',
        _1A: '1A',
        _1Aa: '1AA',
        _25Aa: '2.5AA',
        _05Aa: '0.5AA',
        Lp14: 'LP14',
        Mp25: 'MP25',
        _2Sx: '2SX'
    } as const;
    export type BatterySizeEnum = typeof BatterySizeEnum[keyof typeof BatterySizeEnum];
    export const DataPlanEnum = {
        Unlimited: 'UNLIMITED',
        ThreeKbyte: 'THREE_KBYTE',
        SmithsonianSpecial: 'SMITHSONIAN_SPECIAL',
        PooledThreeKbyte: 'POOLED_THREE_KBYTE',
        PooledTwelveKbyte: 'POOLED_TWELVE_KBYTE',
        Test25Kbyte: 'TEST_2_5_KBYTE',
        Test4Kbyte: 'TEST_4_KBYTE'
    } as const;
    export type DataPlanEnum = typeof DataPlanEnum[keyof typeof DataPlanEnum];
}


export type BatteryShapeEnum = typeof FormDataDto.BatteryShapeEnum[keyof typeof FormDataDto.BatteryShapeEnum];
export type BatterySizeEnum = typeof FormDataDto.BatterySizeEnum[keyof typeof FormDataDto.BatterySizeEnum];
export type DataPlanEnum = typeof FormDataDto.DataPlanEnum[keyof typeof FormDataDto.DataPlanEnum];
